module.exports = __webpack_public_path__ + "vfn-assets/img/img-pasos-membresia-icono.f50ee2db.svg";